import { useDispatch, useSelector } from "react-redux";
import Col from "../element/col";
import Row from "../element/row";
import CommonTitle from "./common.title";
import Container from "../element/container";
import Image from "../element/image";
import { Swiper, SwiperSlide } from "swiper/react";
import useWindowDimension from "../hook/use.window.dimension";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Accessories,
  Bottom,
  Footwear,
  Headwear,
  Jacket,
  Top,
} from "../../assets/images";
import { getCategoryList } from "../../redux/reducer/common.reducer";
import { Skeleton } from "primereact/skeleton";
import { useEffect } from "react";

export default function CommonCategory({ className }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { width } = useWindowDimension();
  const { categoryList, categoryListLoading } = useSelector(
    (state) => state.common
  );

  const CategoryContent = ({ category, index, loading }) => {
    return loading ? (
      <>
        <Skeleton className="category-bg" />
        <Skeleton
          width={width < 750 ? "60px" : width < 1100 ? "90px" : "110px"}
          height={width < 750 ? "12px" : width < 1100 ? "13px" : "15px"}
          borderRadius="0"
        />
      </>
    ) : (
      <>
        <article className="category-bg">
          <Image
            className="_img"
            src={category.media?.length > 0 && category.media[0].url}
          />
        </article>
        <h6 className="_label category-title">{category.name}</h6>
      </>
    );
  };

  const handleNavigate = (category) => {
    if (pathname.includes("/shop")) {
      navigate(`/shop/${category}#product-list`);
    } else {
      navigate(`/shop/${category}`);
    }
  };

  return (
    <Container className={`common-category ${className ?? ""}`}>
      <CommonTitle title="Category" subtitle="Shop By" />
      {width < 750 ? (
        <Swiper
          grabCursor={true}
          slidesPerView="auto"
          spaceBetween={0}
          className="_row category-list"
        >
          {categoryListLoading
            ? Array.from({ length: 6 }, (_, categoryLoadingIndex) => (
                <SwiperSlide
                  className="col-center gap-4 pointer"
                  key={categoryLoadingIndex}
                >
                  <CategoryContent loading />
                </SwiperSlide>
              ))
            : categoryList?.length > 0 &&
              categoryList.map((category, categoryIndex) => (
                <SwiperSlide
                  className="col-center gap-4 pointer"
                  key={categoryIndex}
                  onClick={() => handleNavigate(category.name.toLowerCase())}
                >
                  <CategoryContent category={category} index={categoryIndex} />
                </SwiperSlide>
              ))}
        </Swiper>
      ) : (
        <Row className="_row category-list">
          {categoryListLoading
            ? Array.from({ length: 6 }, (_, categoryLoadingIndex) => (
                <Col
                  className="col-center gap-4 pointer"
                  key={categoryLoadingIndex}
                >
                  <CategoryContent loading />
                </Col>
              ))
            : categoryList?.length > 0 &&
              categoryList.map((category, categoryIndex) => (
                <Col
                  className="col-center gap-4 pointer"
                  key={categoryIndex}
                  onClick={() => handleNavigate(category.name.toLowerCase())}
                >
                  <CategoryContent category={category} index={categoryIndex} />
                </Col>
              ))}
        </Row>
      )}
    </Container>
  );
}
